import { useState } from 'react';
import api from './api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const form = new FormData();
      form.append('Username', username);
      form.append('Password', password);

      const res = await api.post('/Authentication/Login', form);

      if (!res.data.status) {
        setError(res.data.message ?? 'Login failed');
        return;
      }
      sessionStorage.setItem('auth_token', res.data.token);
      sessionStorage.setItem('auth_role', res.data.role ?? '');
      sessionStorage.setItem('auth_name', res.data.name ?? '');
      sessionStorage.setItem('auth_email', res.data.email ?? '');
      onLogin(res.data.token);
    } catch (err) {
      setError(err.response?.data?.message ?? err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#1a1a1a',
    }}>
      <form onSubmit={handleSubmit} style={{
        background: '#2d2d2d', borderRadius: 10, padding: '36px 40px',
        display: 'flex', flexDirection: 'column', gap: 16, minWidth: 320,
        border: '1px solid #444',
      }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 18, marginBottom: 4 }}>
          Console Login
        </span>

        {error && (
          <div style={{
            background: '#7f1d1d', color: '#fecaca', padding: '8px 12px',
            borderRadius: 6, fontSize: 13,
          }}>
            {error}
          </div>
        )}

        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ color: '#9ca3af', fontSize: 12 }}>Username</span>
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
            required
            style={inputStyle}
          />
        </label>

        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span style={{ color: '#9ca3af', fontSize: 12 }}>Password</span>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            style={inputStyle}
          />
        </label>

        <button type="submit" disabled={loading} style={{
          marginTop: 4, padding: '10px', borderRadius: 6, border: 'none',
          background: loading ? '#1e3a5f88' : '#1e3a5f',
          color: '#93c5fd', fontWeight: 600, fontSize: 14,
          cursor: loading ? 'not-allowed' : 'pointer',
        }}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  padding: '8px 10px', borderRadius: 6, border: '1px solid #555',
  background: '#1a1a1a', color: '#fff', fontSize: 13, outline: 'none',
};
